<template>
	<v-menu
		v-model="menu2"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		min-width="auto"
		:disabled="input.disabled"
	>
		<template v-slot:activator="{ on, attrs }">
			<div v-on="on">
				<v-text-field
					v-model="computedDateFormatted"
					:label="input.label"
					:disabled="header.disabled"
					append-icon="mdi-calendar"
					v-bind="attrs"
					hide-details
					readonly
					outlined
				></v-text-field>
			</div>
		</template>
		<v-date-picker
			v-model="date"
			no-title
			@input="menu2 = false"
			locale="es"			
		></v-date-picker>
	</v-menu>
</template>
<script>
import moment from 'moment';
export default {
	name: 'CDatePicker',
	props: {
		input: Object,
	},
	data: () => ({
		menu2: false,
	}),
	computed: {
		header() {
			return this.$store.getters['incident/getHeaderById'](this.input.id);
		},
		date: {
			get() {
				return this.header?.value || null;
			},
			set(value) {
				this.$store.dispatch('incident/updateInputHeader', {
					value,
					id: this.input.id,
				});
			},
		},
		computedDateFormatted() {
			return this.formatDate(this.date);
		},
	},
	created() {
		if (!this.input.value) {
			this.date = moment().format('YYYY-MM-DD');
		}
	},
	methods: {
		formatDate(date) {
			if (!date) return null;
			const [year, month, day] = date.split('-');
			return `${day}-${month}-${year}`;
		},
	},
};
</script>
